
function SuggestController() {
    var _this = this;

    var request = {};

    var response = {};

    var req = false;

    this.init = function() {
        if (jQuery('html').attr('lang') == 'fr') {
            jQuery.ui.autocomplete.prototype.options.messages = {
                noResults: "Aucun résultat.",
                results: function (amount) {
                    return amount + ( amount > 1 ? " suggestions sont disponibles" : " suggestion est disponible" ) +
                        ", utiliser les flèches montée et descendre pour naviguer.";
                }
            };
        }

        // Change back to the old behavior of auto-complete
        // http://jqueryui.com/docs/Upgrade_Guide_184#Autocomplete
        jQuery.ui.autocomplete.prototype._renderItem = function (ul, item) {
            return jQuery('<li></li>').data("item.autocomplete", item).append('<a href="' + item.url + '"><span>' + item.title + "</span><span class='material-symbols-outlined'>arrow_right_alt</span></a>").appendTo(ul);
        };

        jQuery.ui.autocomplete.prototype._close = function (event) {
            // Remove the handler that closes the menu on outside clicks
            this._off( this.document, "mousedown" );

            if ( this.menu.element.is( ":visible" ) ) {
                if (event) {
                    var delay = setInterval($.proxy(function () {
                        this.menu.element.hide();
                        clearInterval(delay);
                    }, this), 2000);
                }
                this.menu.blur();
                this.isNewMenu = true;
                this._trigger( "close", event );
            }
        };

        var req = false;

        jQuery('form[data-suggest]').each(function () {
            var $form = $(this);
            $form.find('.search-panel-input-field').autocomplete({
                appendTo: '.search-panel-content',
                position: {my: "left 0", at: "left 0", of: ".search-panel-content", collision: "none"},
                source: function (request, response) {
                    _this.request = request;
                    _this.response = response;
                    if (req) {
                        req.abort();
                        response();
                    }
                    req = jQuery.ajax({
                        url: $form.data('suggest'),
                        dataType: 'json',
                        data: {
                            tx_solr: {queryString : request.term.toLowerCase()}
                        },
                        success: _this.handleSuggestResponse
                    });
                },
                select: function (event, ui) {
                    this.value = ui.item.value;
                    $form.submit();
                },
                delay: 300,
                minLength: 3
            });
        });
    };

    this.handleSuggestResponse = function (data) {
        req = false;
        var output = [];
        jQuery.each(data.documents, function (i, element) {
            output.push({
                title: element.title.replace(new RegExp('(?![^&;]+;)(?!<[^<>]*)(' +
                    jQuery.ui.autocomplete.escapeRegex(_this.request.term) +
                    ')(?![^<>]*>)(?![^&;]+;)', 'gi'), '<strong>$1</strong>'),
                url: element.link
            });
        });
        _this.response(output);
    };
}
jQuery(document).ready(function () {
    var solrSuggestController = new SuggestController();
    solrSuggestController.init();

    jQuery("body").on("tx_solr_updated", function() {
        solrSuggestController.init();
    });
});
